import Lottie from "react-lottie";
import Link from "next/link";
import React, { FC, useMemo } from "react";
import animation from "../../lp/sydm2/suzu-head-data.json";
import { useDeviceType } from "../../../../lib/util";

// 現在このコンポーネントを使用すると componentWillUpdate をrenameしろという警告が出る。
// react-lottieによるものなので https://github.com/chenqingspring/react-lottie/issues/100 の対応を待つしかない。
const SuzuHead: FC = () => {
  const deviceType = useDeviceType();
  const width = useMemo(() => (deviceType.pc ? 80 : 60), [deviceType]);
  const style = useMemo(
    () => (deviceType.pc ? { margin: "-21px auto" } : { marginRight: "8px" }),
    [deviceType]
  );
  return (
    <Link href="/lp/sydm2">
      <a>
        <Lottie
          style={style}
          width={width}
          options={{
            loop: true,
            animationData: animation,
          }}
        />
      </a>
    </Link>
  );
};
export default SuzuHead;
